import pattern from '../../../pattern.svg';

import { useState, useEffect, useRef } from 'react';

import { useStep } from '../../Base/StepContext';
import { useGlobal } from '../../../Core/GlobalState/Store';
import LoadingSpinner from '../../ReusableComponents/LoadingSpinner';
import RoomAvailabilityService from '../../../Core/Services/RoomAvailabilityService';

import ContainerSelectionBody from './Body/ContainerSelectionBody';
import ContainerSizeSelectorHeader from './Headers/ContainerSizeSelectorHeader';

export default function ContainerSizeSelect() {
  const { handleNext } = useStep();

  const [roomList, setRoomList] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState(0);
  const {
    currentLocation: location,
    pluginUrl,
    loading,
    setLoading,
    sizeTypes,
    setSizeTypes,
    selectedSize,
    setSelectedSize,
    room,
    setRoom,
  } = useGlobal();

  const releasedStaleRoomRef = useRef(false);

  useEffect(() => {
    let isMounted = true;
    // IIFE cause react hook cannot be async directly
    (async () => {
      try {
        setLoading(true);

        if (!releasedStaleRoomRef.current) {
          releasedStaleRoomRef.current = true;
          if (room) {
            await setRoom(null);
          }
          if (selectedSize) {
            setSelectedSize(null);
          }
        }

        // You need to have a location selected to fetch the available rooms,
        // you should never reach this point without a location
        if (!location || !location.orderNumber) {
          setLoading(false);
          return;
        }

        const rooms =
          await RoomAvailabilityService.fetchAvailableRoomsByLocationId(
            location.orderNumber
          );
        if (isMounted) {
          setRoomList(rooms);
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    })();
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  useEffect(() => {
    try {
      const newSizeTypes =
        RoomAvailabilityService.addFromPriceAndAvailableAmountToSizeTypes(
          roomList,
          sizeTypes
        );
      setSizeTypes(newSizeTypes);

      if (selectedSize) {
        const updatedSelectedSize = newSizeTypes.find(
          type => type.id === selectedSize.id
        );
        setSelectedSize(
          updatedSelectedSize && updatedSelectedSize.availableAmount > 0
            ? updatedSelectedSize
            : null
        );
      }
    } catch (e) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roomList]);

  return (
    <div
      className="w-full flex flex-col " // !border-solid !border-l !border-r border-gray-300 border-1
     /*  style={{
        backgroundImage: `url(${pluginUrl + pattern})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top right',
      }} */
    >
      <ContainerSizeSelectorHeader />

      {loading && (
        <div className="flex justify-center items-center h-[400px]">
          <LoadingSpinner />
        </div>
      )}

      {!loading && (
        <ContainerSelectionBody
          sizeTypes={sizeTypes}
          selectedSize={selectedSize}
          setSelectedSize={setSelectedSize}
          selectedLevel={selectedLevel}
          setSelectedLevel={setSelectedLevel}
          roomList={roomList}
          handleNext={handleNext}
        />
      )}
    </div>
  );
}
